module.exports = __webpack_public_path__ + "img/s8_pen3.f67584f8.png";